import {
  GET_PROFILE_DETAILS,
  GET_ALLOCATOR_Strategy,
  UPDATE_ALLOCATOR_STRATEGY,
  GET_STRATEGY,
  GET_ALL_INVESTOR,
  UPDATE_TENET_DETIALS,
  UPDATE_COVERIMAGE,
  UPDATE_COMPANYLOGO,
  GET_COMPANY_POST_FEED,
  GET_COMPANY_USERS,
  GET_FUND_SPOTLIGHTS,
  GET_ALLOCATOR_INFO,
  UPDATE_ALLOCATOR_INFO,
  CREATE_ALLOCATOR_INFO,
  UPDATE_IDP,
  UPDATE_NDE,
  UPDATE_FSI,
  UPDATE_IC,
} from "./constants";

export function getProfileDetail(payload) {
  return {
    type: GET_PROFILE_DETAILS,
    payload,
  };
}

export function getAllocatorStrategy(payload) {
  return {
    type: GET_ALLOCATOR_Strategy,
    payload,
  };
}

export function getStrategy(payload) {
  return {
    type: GET_STRATEGY,
    payload,
  };
}
export function updateAllocatorStratgy(payload) {
  return {
    type: UPDATE_ALLOCATOR_STRATEGY,
    payload,
  };
}

export function getallInvestorAction(payload) {
  return {
    type: GET_ALL_INVESTOR,
    payload,
  };
}

export function updateTenantDetail(payload, onSuccess) {
  return {
    type: UPDATE_TENET_DETIALS,
    payload,
    onSuccess
  };
}

export function updateTenantCoverImage(payload, onSuccess, onCloseModal) {
  return {
    type: UPDATE_COVERIMAGE,
    payload,
    onSuccess,
    onCloseModal
  };
}

export function updateTenantCompanyLogo(payload, onSuccess , onCloseModal) {
  return {
    type: UPDATE_COMPANYLOGO,
    payload,
    onSuccess,
    onCloseModal
  };
}

export function getCompanyPostFeedAction(payload) {
  return {
    type: GET_COMPANY_POST_FEED,
    payload,
  };
}

export function getCompanyUsersAction() {
  return {
    type: GET_COMPANY_USERS
  };
}

export function getFundSpotlightAction(payload) {
  return {
    type: GET_FUND_SPOTLIGHTS,
    payload,
  };
}

export function createAllocatorInfoAction(payload, onSuccess) {
  return {
    type: CREATE_ALLOCATOR_INFO,
    payload,
    onSuccess
  };
}

export function updateAllocatorInfoAction(payload, onSuccess) {
  return {
    type: UPDATE_ALLOCATOR_INFO,
    payload,
    onSuccess
  };
}

export function getAllocatorInfoAction() {
  return {
    type: GET_ALLOCATOR_INFO,
  };
}

export function updateIDPAction(payload, onSuccess) {
  return {
    type: UPDATE_IDP,
    payload,
    onSuccess
  };
}

export function updateFSIAction(payload, onSuccess) {
  return {
    type: UPDATE_FSI,
    payload,
    onSuccess
  };
}

export function updateNDEAction(payload, onSuccess) {
  return {
    type: UPDATE_NDE,
    payload,
    onSuccess
  };
}
export function updateInvestorCategoryAction(payload, onSuccess) {
  return {
    type: UPDATE_IC,
    payload,
    onSuccess
  };
}